"use client";

import {  useNavigate  } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function SettingsBackButton() {
    const navigate = useNavigate();

    return (
        <button
            type="button"
            onClick={() => {
                if (typeof window !== "undefined" && window.history.length > 1) {
                    navigate(-1);
                    return;
                }
                navigate("/courses");
            }}
            className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900"
            aria-label="Go back"
        >
            <ArrowLeft className="h-4 w-4" />
        </button>
    );
}
